import { lazy } from 'react';

/**
 * 우측 사이드 패널(widget-container.js)에 표시 가능한 위젯의 단일 정의 소스.
 * 새 위젯을 추가하려면 이 배열에 항목을 추가하기만 하면 된다 — widget-container.js,
 * 설정 UI는 모두 이 레지스트리를 순회해서 렌더링한다.
 *
 * - id: localStorage에 저장되는 고유 키 (변경 시 기존 사용자 설정과의 호환이 깨짐)
 * - removable: false면 패널 편집 모드에서 숨김 처리할 수 없음 (알림처럼 항상 보여야 하는 위젯)
 * - grow: true면 남은 세로 공간을 채움 (widget-item-chat과 동일한 동작). 패널 내 최대 1개만 권장.
 * - description: 편집 모드에서 실제 위젯 대신 보여주는 한 줄 설명 (단축형 미리보기)
 */
const SIDE_PANEL_WIDGETS = [
    {
        id: 'notification',
        label: '알림',
        icon: 'notifications',
        description: '읽지 않은 알림을 모아 보여줍니다',
        component: lazy(() => import('../components/widget/widget-notification.js')),
        defaultEnabled: true,
        removable: false,
    },
    {
        id: 'calendar',
        label: '활동 달력',
        icon: 'calendar_month',
        description: '게시글 작성 활동을 달력으로 보여줍니다',
        component: lazy(() => import('../components/widget/widget-calendar.js')),
        defaultEnabled: true,
        removable: true,
    },
    {
        id: 'gigTasks',
        label: 'GIG 마감 임박',
        icon: 'task_alt',
        description: '마감이 임박한 담당 플랜을 보여줍니다',
        component: lazy(() => import('../components/widget/widget-gig-tasks.js')),
        defaultEnabled: true,
        removable: true,
    },
    {
        id: 'quickMemo',
        label: '빠른 메모',
        icon: 'sticky_note_2',
        description: '간단한 메모를 기록합니다',
        component: lazy(() => import('../components/widget/widget-quick-memo.js')),
        defaultEnabled: false,
        removable: true,
    },
    {
        id: 'chat',
        label: '채팅',
        icon: 'chat',
        description: '참여 중인 채팅방과 메시지를 보여줍니다',
        component: lazy(() => import('../components/widget/widget-chat.js')),
        defaultEnabled: true,
        removable: true,
        grow: true,
    },
    {
        id: 'aiAssistant',
        label: 'GPT 어시스턴트',
        icon: 'auto_awesome',
        description: '연결된 GPT 세션으로 제목·본문·요약·태그를 도와줍니다',
        component: lazy(() => import('../components/widget/widget-ai-assistant.js')),
        defaultEnabled: false,
        removable: true,
    },
];

export default SIDE_PANEL_WIDGETS;
